import { render, staticRenderFns } from "./ExchangeTheAuthorisationCodeToAnAccessToken.vue?vue&type=template&id=098e20a1&scoped=true"
import script from "./ExchangeTheAuthorisationCodeToAnAccessToken.vue?vue&type=script&lang=js"
export * from "./ExchangeTheAuthorisationCodeToAnAccessToken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098e20a1",
  null
  
)

export default component.exports